module.exports = __webpack_public_path__ + "static/media/toyota-full.048818c6.png";